import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import { Swipe } from '@yme/assets/icons';
import { AlertType } from '@yme/atoms/alert';
import { AlertStyled, ScrollableContainerStyled, TableContainerStyled, } from '@yme/components/Cookies/CookieTable/styled';
import { IndentWrapper } from '@yme/components/Separator';
import { useMouseDrag, useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import sanitizeWhiteList from '@yme/utils/sanitize-html.whitelist';
export function CookieTable({ tableData, isRemoveBottomIndent, }) {
    const ref = useRef(null);
    const isRightToLeft = useSelector(getRTL);
    const { mouseEventHandlers } = useMouseDrag(ref);
    const { isInfiniteDesktopView } = useWindowSize();
    const { t } = useTranslation();
    const [isLeftGradientVisible, setIsLeftGradientVisible] = useState(false);
    const [isRightGradientVisible, setIsRightGradientVisible] = useState(false);
    useEffect(() => {
        if (ref.current) {
            const { current } = ref;
            setIsRightGradientVisible(current.scrollLeft + current.clientWidth < current.scrollWidth);
        }
    }, []);
    const updateGradientVisibility = useCallback(() => {
        if (ref.current) {
            const { current } = ref;
            setIsLeftGradientVisible(current.scrollLeft > 0);
            setIsRightGradientVisible(current.scrollLeft + current.clientWidth < current.scrollWidth);
        }
    }, []);
    useEffect(() => {
        const { current } = ref;
        if (current) {
            current.addEventListener('scroll', updateGradientVisibility);
        }
        return () => {
            if (current) {
                current.removeEventListener('scroll', updateGradientVisibility);
            }
        };
    }, [updateGradientVisibility]);
    if (!tableData) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        !isInfiniteDesktopView && (isLeftGradientVisible || isRightGradientVisible) && (React.createElement(AlertStyled, { type: AlertType.MESSAGE, customIcon: Swipe, message: t('cookies_swipeHorizontallyToBrowseTable_message') })),
        React.createElement(ScrollableContainerStyled, { isRightToLeft: isRightToLeft, isLeftGradientVisible: isLeftGradientVisible, isRightGradientVisible: isRightGradientVisible },
            React.createElement(TableContainerStyled, { ref: ref, ...mouseEventHandlers, isHorizontal: true, isRightToLeft: isRightToLeft, dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(tableData, sanitizeWhiteList),
                } }))));
}
CookieTable.displayName = 'CookieTable_AEMComponent';
